import React from 'react';
import { Navbar } from '../components/Navbar';
import { MediaInsightsPage } from '../components/MediaInsightsPage';
import { Footer } from '../components/Footer';
export const Media = () => {
  return <div className="font-sans text-gray-800 bg-white" data-id="element-2349" data-mp="2p1bdltw69qae">
      <Navbar data-id="element-2350" data-mp="2p35xd4vpjccw" />
      <MediaInsightsPage data-id="element-2351" data-mp="2k1yqd81e2h7a" />
      <Footer data-id="element-2352" data-mp="2k1ozli8is60j" />
    </div>;
};